// Real covers and pages, hosted in the store's Impultienda Recursos.
const BASE = 'https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/c6c13986-742a-4d30-9e76-1e11ca69b69b/';

export const I = {
  hero: BASE + '1792803345591_hero.webp',
  page1: BASE + '1792803346618_page1.webp',
  page2: BASE + '1792803347392_page2.webp',
  page3: BASE + '1792803348416_page3.webp',
  page4: BASE + '1792803349432_page4.webp',
  page5: BASE + '1792803350430_page5.webp',
  page6: BASE + '1792803351186_page6.webp',
  tomo1: BASE + '1792803351920_tomo1.webp',
  tomo2: BASE + '1792803353070_tomo2.webp',
  tomo3: BASE + '1792803353855_tomo3.webp',
  tomo4: BASE + '1792803354589_tomo4.webp',
  tomo5: BASE + '1792803355375_tomo5.webp',
  tomo6: BASE + '1792803356217_tomo6.webp',
  bono1: BASE + '1792803342585_bono1.webp',
  bono2: BASE + '1792803343359_bono2.webp',
  bono3: BASE + '1792803344039_bono3.webp',
  bono4: BASE + '1792803344730_bono4.webp',
};
